"use client";

import type { FC, Ref } from "react";
import { ViewingTipsCard, type ViewingTipsCardProps } from "@huub-web/shared";
import { Button } from "@huub-web/ui/components/Button";
import type { UIAction } from "@huub-web/ui/types/UIAction";
import { useActions } from "@huub-web/ui/hooks/useActions";

export interface TipsCardTemplateProps {
  /**
   * Title of the tips card
   */
  title?: string;
  /**
   * Subtitle of the tips card
   */
  subtitle?: string;
  /**
   * Value of the tips card
   */
  value?: string;
  /**
   * Array of tips to display
   */
  tips?: ViewingTipsCardProps["tips"];
  /**
   * Wrap the tips card in a container
   */
  action?: UIAction;
}

/**
 * @deprecated 💀
 */
export const TipsCardTemplate: FC<
  TipsCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, subtitle, tips, action, value, ref }) => {
  const { handleAction } = useActions();

  const handleClick = () => {
    if (action) {
      handleAction(action);
    }
  };

  return (
    <ViewingTipsCard
      ref={ref}
      cta={
        !!value &&
        !!action && (
          <Button
            variant="primary"
            size="s"
            onClick={handleClick}
            // trailing={<Icon icon="arrowRight" size="s" />}
          >
            {value}
          </Button>
        )
      }
      title={title}
      subtitle={subtitle}
      tips={tips}
    />
  );
};
